import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import {
  getReservationsPerRegionRequest,
  createReservationGetTablesRequest,
  createReservationRequest,
  editReservationRequest,
  deleteReservationRequest,
  getTablesAndReservationPerRegionRequest,
  createReservationClientHistoryRequest,
} from "../../services/reservationService";
import { getToken } from "../../utils/utility";
import { notification } from "antd";

export function* getTablesAndReservationPerRegion(getReservationsData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      getTablesAndReservationPerRegionRequest,
      token,
      getReservationsData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_TABLES_AND_RESERVATIONS_PER_REGION_SUCCESS,
        tablesWithReservations: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* getReservationsPerRegion(getReservationsData) {
  try {
    const token = getToken().get("idToken");

    const response = yield call(
      getReservationsPerRegionRequest,
      token,
      getReservationsData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.GET_RESERVATIONS_PER_REGION_SUCCESS,
        reservations: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* createReservationGetTables(reservationTablesData) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      createReservationGetTablesRequest,
      token,
      reservationTablesData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.CREATE_RESERVATIONS_GET_TABLES_SUCCESS,
        reservationTables: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* createReservation(createReservationData) {
  try {
    const token = getToken().get("idToken");
    const selectedDate = createReservationData.createReservationData.date;

    const response = yield call(
      createReservationRequest,
      token,
      createReservationData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.CREATE_RESERVATIONS_SUCCESS,
        reservation: response[1],
        date: selectedDate,
      });
      yield put({
        type: actions.CLOSE_RESERVATION_CREATE_MODAL,
      });
      notification["success"]({
        message: "Успешно създаване на резервация",
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* editReservation(editReservationData) {
  try {
    const token = getToken().get("idToken");
    // Selected date to check in reducer if the dates matches and to decide to show or hide the reservation
    const selectedDate = editReservationData.editReservationData.date;
    const response = yield call(
      editReservationRequest,
      token,
      editReservationData
    );
    if (response[0] === 200) {
      yield put({
        type: actions.EDIT_RESERVATIONS_SUCCESS,
        reservation: response[1],
        date: selectedDate,
      });
      yield put({
        type: actions.CLOSE_RESERVATION_EDIT_MODAL,
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* deleteReservation(reservationId) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(deleteReservationRequest, token, reservationId);
    if (response[0] === 200) {
      yield put({
        type: actions.DELETE_RESERVATIONS_SUCCESS,
        deletedReservation: response[1],
      });
      yield put({
        type: actions.CLOSE_RESERVATION_EDIT_MODAL,
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* createReservationClientHistory(
  createReservationClientHistoryData
) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      createReservationClientHistoryRequest,
      token,
      createReservationClientHistoryData
    );
    if (response[0] === 200 || response[0] === 404) {
      yield put({
        type: actions.CREATE_RESERVATIONS_CLIENT_HISTORY_SUCCESS,
        clientReservationHistory: response[1],
      });
    } else if (response[0] === 500) {
      notification["error"]({
        message: "Няма връзка с базата",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(
      actions.GET_TABLES_AND_RESERVATIONS_PER_REGION_REQUEST,
      getTablesAndReservationPerRegion
    ),
    yield takeEvery(
      actions.GET_RESERVATIONS_PER_REGION_REQUEST,
      getReservationsPerRegion
    ),
    yield takeEvery(
      actions.CREATE_RESERVATIONS_GET_TABLES_REQUEST,
      createReservationGetTables
    ),
    yield takeEvery(actions.CREATE_RESERVATIONS_REQUEST, createReservation),
    yield takeEvery(actions.EDIT_RESERVATIONS_REQUEST, editReservation),
    yield takeEvery(actions.DELETE_RESERVATIONS_REQUEST, deleteReservation),
    yield takeEvery(
      actions.CREATE_RESERVATIONS_CLIENT_HISTORY_REQUEST,
      createReservationClientHistory
    ),
  ]);
}
